import React from 'react';

const GROUPS = [
  {
    label: 'General',
    fields: [
      { key: 'enabled', label: 'Product Enabled' },
      { key: 'featured', label: 'Featured Product' },
      { key: 'new', label: 'Mark as New' },
      { key: 'available', label: 'Available' },
      { key: 'onSale', label: 'On Sale' },
    ]
  },
  {
    label: 'Display',
    fields: [
      { key: 'showInCatalog', label: 'Show in Catalog' },
      { key: 'showOnHomepage', label: 'Show on Homepage' },
      { key: 'showInCategory', label: 'Show in Category' },
      { key: 'showInSearch', label: 'Show in Search' },
      { key: 'showInRelated', label: 'Show in Related' },
      { key: 'showPrice', label: 'Show Price' },
      { key: 'showSpecifications', label: 'Show Specifications' },
      { key: 'showGallery', label: 'Show Gallery' },
    ]
  },
  {
    label: 'Features',
    fields: [
      { key: 'showDemoLink', label: 'Show Demo Link' },
      { key: 'showDownloadLink', label: 'Show Download Link' },
      { key: 'showContactForm', label: 'Show Contact Form' },
    ]
  }
];

const VisibilitySection = ({ formData, handleNestedChange }) => {
  const visibility = formData.visibility || {};

  return (
    <div className="form-section">
      <h3>Visibility Settings</h3>

      {GROUPS.map(group => (
        <div key={group.label} className="visibility-group">
          <label className="visibility-group-label">{group.label}</label>
          <div className="checkbox-grid">
            {group.fields.map(field => (
              <div key={field.key} className="checkbox-item">
                <label>
                  <input
                    type="checkbox"
                    checked={visibility[field.key] || false}
                    onChange={(e) => handleNestedChange(`visibility.${field.key}`, e.target.checked)}
                  />
                  {field.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      ))}

      <div className="visibility-group">
        <label className="visibility-group-label">Seasonal</label>
        <div className="form-row">
          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={visibility.seasonal || false}
                onChange={(e) => handleNestedChange('visibility.seasonal', e.target.checked)}
              />
              Seasonal Product
            </label>
          </div>
        </div>
        {visibility.seasonal && (
          <div className="form-row">
            <div className="form-group">
              <label>Season Start</label>
              <input
                type="date"
                className="form-control"
                value={visibility.seasonStart || ''}
                onChange={(e) => handleNestedChange('visibility.seasonStart', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Season End</label>
              <input
                type="date"
                className="form-control"
                value={visibility.seasonEnd || ''}
                onChange={(e) => handleNestedChange('visibility.seasonEnd', e.target.value)}
              />
            </div>
          </div>
        )}
      </div>

      <div className="form-group">
        <label>Priority (1-10, higher = shown first)</label>
        <input
          type="number"
          min="1"
          max="10"
          className="form-control"
          style={{ width: '120px' }}
          value={visibility.priority ?? 5}
          onChange={(e) => handleNestedChange('visibility.priority', parseInt(e.target.value) || 5)}
        />
      </div>
    </div>
  );
};

export default VisibilitySection;
